'use client';
import { ReactComponent } from './logo.svg';
export const LogoIcon = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=logo.js.map